const SHIPPOP = "shippop";
const MASTER = "master";
const SUPERADMIN = "superadmin";
const ADMIN = "admin";
const MEMBER = "member";
const PAYMENT_TYPE_PREPAID = "PREPAID";
let userDetails = null;

const userLogin = {
  get() {
    const user = this.loadCurrentUser();
    if (user == false) {
      return null;
    }

    return {
      details             : userDetails,
      isShippop           : this.isShippop(),
      isMaster            : this.isMaster(),
      isSuperadmin        : this.isSuperadmin(),
      isAdmin             : this.isAdmin(),
      isMember            : this.isMember(),
      isUnderByShippop    : this.isUnderByShippop(),
      isPaymentTypePrepaid: this.isPaymentTypePrepaid(),
    };
  },
  loadCurrentUser() {
    return (userDetails = JSON.parse(localStorage.getItem("user")));
  },
  isShippop() {
    return userDetails.role == SHIPPOP;
  },
  isMaster() {
    return userDetails.role == MASTER;
  },
  isSuperadmin() {
    return userDetails.role == SUPERADMIN;
  },
  isAdmin() {
    return userDetails.role == ADMIN;
  },
  isMember() {
    return userDetails.role == MEMBER;
  },
  isUnderByShippop() {
    return userDetails.under_by == SHIPPOP;
  },
  isPaymentTypePrepaid() {
    return userDetails.payment_type === PAYMENT_TYPE_PREPAID;
  },
};

export default userLogin;
